import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class UserOrderService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    getProducts(data): Observable<any> {
        return this.getRequest(AppUrl.USER_PRODUCT_ORDER(), data);
    }

    getProductsCount(data): Observable<any> {
        return this.getRequest(AppUrl.USER_PRODUCT_ORDER_COUNT(), data);
    }

    getPackages(data): Observable<any> {
        return this.getRequest(AppUrl.USER_PACKAGES_ORDER(), data);
    }

    getPackagesCount(data): Observable<any> {
        return this.getRequest(AppUrl.USER_PACKAGES_ORDER_COUNT(), data);
    }

    orderDeliveredStatus(data, id): Observable<any> {
        return this.putRequest(AppUrl.ORDER_DELIVERED_STATUS(id), data);
    }

    packageOrderDeliveredStatus(data, id): Observable<any> {
        return this.putRequest(AppUrl.PACKAGE_ORDER_DELIVERED_STATUS(id), data);
    }

    orderCancelledStatus(data, id): Observable<any> {
        return this.putRequest(AppUrl.ORDER_CANCELLED_STATUS(id), data);
    }

    downloadUserProductOrderReport(data): Observable<any> {
        return this.getRequest(AppUrl.DOWNLOAD_USER_PRODUCT_ORDER_REPORT(), data);
    }

    downloadUserPackageOrderReport(data): Observable<any> {
        return this.getRequest(AppUrl.DOWNLOAD_USER_PACKAGE_ORDER_REPORT(), data);
    }

}
